import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import Header from "../../../layouts/Header.jsx";
import GalleryModal from "./GalleryModal.jsx";
import RemarksModal from "./RemarksModal.jsx";
import { axios_instance } from "../../../api/axios_instance.js";
import WithheldTable from "../../../layouts/WithheldTable.jsx";
import RefreshSpin from "../../../layouts/RefreshSpin.jsx";
import { resetWithheldSortingColumns } from "../../../utils/constant.js";
import PayeeDetailsModal from "./PayeeDetailsModal.jsx";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "./ConfirmationModal.jsx";
import MultiSelectDropDownReset from "../../../layouts/MultiSelectDropdownReset.jsx";
import { decryptRequest } from "../../../utils/encryptdecryptrequest.js";

const WithheldPanel = () => {
  const user = useSelector((state) => state.user);

  const initialFilterState = useMemo(
    () => ({
      regNo: "",
      cities: [],
      subStatuses: [10, 11, 12],
      rtoAgents: [],
      statuses: [],
    }),
    []
  );

  const [filterValues, setFilterValues] = useState(initialFilterState);

  const initialDropDownData = useMemo(
    () => ({
      cities: [],
      subStatuses: [],
      rtoAgents: [],
      statuses: [],
    }),
    []
  );

  const [dropdownData, setDropdownData] = useState(initialDropDownData);

  const [sortingColumns, setSortingColumns] = useState({
    ...resetWithheldSortingColumns,
  });
  const [selectedSortingCol, setSelectedSortingCol] = useState({
    lead_id: -1,
  });

  const [caseDetails, setCaseDetails] = useState({ caseData: [], tabCount: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [showPayeeDetailsModal, setShowPayeeDetailsModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showArrowTopButton, setShowArrowTopButton] = useState(false);
  const [resetClicked, setResetClicked] = useState(false);

  const [propsState, setPropsState] = useState({
    galleryModalProps: {},
    remarkModalProps: {},
    payeeDetailProps: {},
  });

  const [withheldCheckboxes, setWithHeldCheckboxes] = useState({});
  const [visibilityObj, setVisibilityObj] = useState({});
  const [caseDetailsCalled, setCaseDetailsCalled] = useState(false);

  const dropdownContainer = useRef(null);
  const dropdownContainer2 = useRef(null);
  const dropdownContainer3 = useRef(null);
  const dropdownContainer4 = useRef(null);

  const filterValuesRef = useRef(filterValues);
  const caseDetailsRef = useRef(caseDetails);

  const dropdownContainers = useMemo(
    () => [
      dropdownContainer,
      dropdownContainer2,
      dropdownContainer3,
      dropdownContainer4,
    ],
    []
  );

  const closeAllDropdowns = useCallback(
    (target) => {
      dropdownContainers
        .filter((container) => container !== target)
        .forEach((container) => {
          const ul = container.current;
          if (ul && ul.classList.contains("visible")) {
            ul.classList.remove("visible");
            ul.style.display = "none";
          }
        });
    },
    [dropdownContainers]
  );

  const handleDocumentClick = useCallback(
    (e) => {
      if (
        !dropdownContainers.some(
          (container) =>
            container.current && container.current.contains(e.target)
        )
      ) {
        closeAllDropdowns();
      }
    },
    [dropdownContainers, closeAllDropdowns]
  );

  const fetchVisibilityData = useCallback(async () => {
    try {
      const resp = await axios_instance({
        url: "/rbac/getWithheldPanelVisibility",
        method: "POST",
        data: {
          caseData: caseDetails.caseData.map(({ sub_stage }) => sub_stage),
        },
      });
      setVisibilityObj((prevState) => ({
        ...prevState,
        ...resp.data,
      }));
    } catch (error) {
    } finally {
      setCaseDetailsCalled(false);
    }
  }, [caseDetails.caseData]);

  const fetchListData = useCallback(
    async (
      closePayeeDetailsModal,
      closeRemarksModal,
      lead_id,
      closeConfirmationModal
    ) => {
      setIsLoading(true);

      if (closePayeeDetailsModal) {
        setShowPayeeDetailsModal(false);
      }
      if (closeRemarksModal) {
        setShowRemarksModal(false);
      }
      if (lead_id) {
        setWithHeldCheckboxes((prevState) => ({
          ...prevState,
          [lead_id]: false,
        }));
      }
      if (closeConfirmationModal) {
        const data = {};

        caseDetailsRef.current.caseData.forEach(({ finance_lead_id }) => {
          data[finance_lead_id] = false;
        });

        setWithHeldCheckboxes((prevState) => ({ ...prevState, ...data }));
        // setShowConfirmationModal(false);
      }

      try {
        const caseresponse = await axios_instance({
          url: "/wp/getWithheldList",
          method: "POST",
          data: {
            filterValues: filterValuesRef.current,
            sortingColumns: selectedSortingCol,
            page,
          },
        });

        setCaseDetails((prevCaseDetails) => ({
          ...prevCaseDetails,
          caseData: caseresponse.data.pageOfResults,
          tabCount: caseresponse.data.counts,
        }));
        setCaseDetailsCalled(true);
      } catch (error) {
        if (error.response && error.response.status !== 500) {
        }
      } finally {
        setIsLoading(false);
      }
    },
    [page, selectedSortingCol]
  );

  const fetchDropDownData = useCallback(async () => {
    try {
      const res = await axios_instance({
        url: "/wp/getWithHeldPanelDropDown",
        method: "GET",
      });

      const { subStatuses, rtoAgents, statuses, cities } = decryptRequest(
        res.data.data
      );

      setDropdownData((prevState) => ({
        subStatuses,
        rtoAgents,
        statuses,
        cities,
      }));
    } catch (error) {}
  }, []);

  useEffect(() => {
    fetchListData();

    document.addEventListener("click", handleDocumentClick);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [fetchListData, sortingColumns, page, handleDocumentClick]);

  useEffect(() => {
    fetchDropDownData();
  }, [fetchDropDownData]);

  useEffect(() => {
    if (caseDetailsCalled) {
      fetchVisibilityData();
    }
  }, [caseDetails.caseData, fetchVisibilityData, caseDetailsCalled]);

  const handleCheckboxChange = (e, filterName) => {
    const { name, checked, value } = e.target;
    let temp = null;

    if (name === "selectall") {
      if (checked)
        temp = dropdownData[filterName].map(({ value }) => parseInt(value));
      else temp = [];
    } else {
      temp = [...filterValues[filterName]];

      if (checked) temp.push(parseInt(value));
      else temp = temp.filter((elem) => elem !== parseInt(value));
    }

    setFilterValues((prevState) => {
      const newFilterValues = {
        ...prevState,
        [filterName]: temp,
      };

      filterValuesRef.current = newFilterValues;
      return newFilterValues;
    });
  };

  const handleWithheldTableCheckboxChange = (e, lead_id) => {
    const { name, checked } = e.target;
    let data = {};

    if (name === "selectall") {
      caseDetails.caseData.forEach(({ finance_lead_id, isMismatch }) => {
        data[finance_lead_id] = {
          checked,
          isMismatch,
        };
      });
    } else {
      const row = caseDetails.caseData.find(
        (item) => item.finance_lead_id === lead_id
      );

      data = {
        [lead_id]: {
          checked,
          isMismatch: row?.isMismatch || false,
        },
      };
    }

    setWithHeldCheckboxes((prevState) => ({
      ...prevState,
      ...data,
    }));
  };

  const handleSorting = async (filterName) => {
    let col = sortingColumns;
    const order = [0, -1].includes(col[filterName]) ? 1 : -1;

    col = { ...resetWithheldSortingColumns };
    col[filterName] = order;
    setSortingColumns(col);

    setSelectedSortingCol({ [filterName]: order });
  };

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowArrowTopButton(true);
    } else {
      setShowArrowTopButton(false);
    }
  };

  const toggleDropDown = (container, e) => {
    closeAllDropdowns(container);
    const ul = container.current;
    if (ul.classList.contains("visible")) {
      ul.classList.remove("visible");
      ul.style.display = "none";
    } else {
      ul.classList.add("visible");
      ul.style.display = "block";
    }
    e.stopPropagation();
  };

  const countSelectedCheckboxes = () => {
    let count = 0;
    for (const val of Object.values(withheldCheckboxes)) {
      if (val.checked) count++;
    }
    return count;
  };

  const pageSelected = (e, pageNo) => {
    e.preventDefault();
    setPage(pageNo);
  };

  const prevPage = (e) => {
    e.preventDefault();
    setPage((prevPage) => prevPage - 1);
  };

  const nextPage = (e) => {
    e.preventDefault();
    setPage((prevPage) => prevPage + 1);
  };

  const openConfirmationModal = (e) => {
    if (countSelectedCheckboxes() < 1) {
      return window.alert("Please select a case to proceed");
    }
    setShowConfirmationModal(true);
    e.stopPropagation();
  };

  const openGalleryModal = (
    finance_lead_id,
    sub_stage,
    name,
    last_name,
    bank_name,
    regno,
    current_balance
  ) => {
    setShowGalleryModal(true);
    setPropsState((prevState) => ({
      ...prevState,
      galleryModalProps: {
        ...prevState.galleryModalProps,
        finance_lead_id,
        sub_stage,
        name,
        last_name,
        bank_name,
        regno,
        current_balance,
      },
    }));
  };
  const openRemarksModal = (
    finance_lead_id,
    disbursement_id,
    sub_stage,
    idx
  ) => {
    setShowRemarksModal(true);
    setPropsState((prevState) => ({
      ...prevState,
      remarkModalProps: {
        ...prevState.remarkModalProps,
        finance_lead_id,
        disbursement_id,
        sub_stage,
        idx,
      },
    }));
  };
  const openPayeeDetailsModal = (finance_lead_id, sub_stage) => {
    setShowPayeeDetailsModal(true);

    setPropsState((prevState) => ({
      ...prevState,
      payeeDetailProps: {
        ...prevState.payeeDetailProps,
        finance_lead_id,
        sub_stage,
      },
    }));
  };

  useEffect(() => {
    if (resetClicked) {
      setFilterValues(() => {
        const newFilterValues = initialFilterState;
        filterValuesRef.current = newFilterValues;

        return newFilterValues;
      });

      setSelectedSortingCol({ lead_id: -1 });

      setPage(1);
      setSortingColumns({ ...resetWithheldSortingColumns });
      setWithHeldCheckboxes({});

      setResetClicked(false);
    }
  }, [resetClicked, initialDropDownData, initialFilterState]);

  const resetFunc = async (e) => {
    e.preventDefault();
    setResetClicked(true);
  };

  return (
    <span>
      <Header
        isNavigationModal={showNavigationModal}
        closeNavigationModal={() => setShowNavigationModal(false)}
        openNavigationModal={() => setShowNavigationModal(true)}
      ></Header>

      <GalleryModal
        galleryModalProps={propsState.galleryModalProps}
        closeGalleryModal={() => setShowGalleryModal(false)}
        showGalleryModal={showGalleryModal}
      />

      <RemarksModal
        showRemarkTextArea={visibilityObj.showRemarkTextArea}
        remarkModalProps={propsState.remarkModalProps}
        fetchListData={fetchListData}
        closeRemarksModal={() => setShowRemarksModal(false)}
        showRemarksModal={showRemarksModal}
      />

      <PayeeDetailsModal
        payeeDetailProps={propsState.payeeDetailProps}
        fetchListData={fetchListData}
        closePayeeDetailsModal={(e) => {
          e?.preventDefault();
          setShowPayeeDetailsModal(false);
        }}
        showPayeeDetailsModal={showPayeeDetailsModal}
      />

      <ConfirmationModal
        withheldCheckboxes={withheldCheckboxes}
        setWithHeldCheckboxes={setWithHeldCheckboxes}
        fetchListData={fetchListData}
        visibilityObj={visibilityObj}
        closeConfirmationModal={() => setShowConfirmationModal(false)}
        showConfirmationModal={showConfirmationModal}
        setIsLoading={setIsLoading}
      />

      <ToastContainer
        closeOnClick={false}
        draggable={false}
        closeButton={false}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="main_wrapper">
            <div className="overlay" id="navigation-overly"></div>
            <section className="right_wrapper">
              <div className="panel-white">
                <div className="grayFiltr-bg brdr-FB clearfix">
                  <div className="col-md-12 ">
                    <h3 className="list_title clearfix pull-left">
                      WithHeld Panel
                    </h3>
                  </div>
                </div>
                <div className="filter_flyout">
                  <div className="filter_box fm-filter filter-section-bx" id="">
                    <div className="row pad-L10">
                      <form id="form-filter-withheld">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 pad-LR">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control search_icon pad-L30"
                              name="regno"
                              id="reg_no"
                              value={filterValues.regNo}
                              onChange={(e) => {
                                e.preventDefault();

                                setFilterValues((prevFilterValues) => {
                                  const newFilterValues = {
                                    ...prevFilterValues,
                                    regNo: e.target.value,
                                  };

                                  filterValuesRef.current = newFilterValues;
                                  return newFilterValues;
                                });
                              }}
                              placeholder="Loan ID, Reg No., Customer or Dealer Name"
                            />
                          </div>
                        </div>

                        {visibilityObj.showCityOptions ? (
                          <div className="col-lg-2 col-md-2 col-sm-6 ms-drpdwn ">
                            <MultiSelectDropDownReset
                              data={dropdownData.cities}
                              handleCheckboxChange={handleCheckboxChange}
                              toggleDropDown={toggleDropDown}
                              dropdownContainer={dropdownContainer}
                              title="Select City"
                              filterName="cities"
                              selectedDropdownData={filterValues.cities}
                            ></MultiSelectDropDownReset>
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="col-lg-3 col-md-3 col-sm-6 ms-drpdwn pad-LR">
                          <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-7 mrg-all-0 pad-R5">
                              <MultiSelectDropDownReset
                                data={dropdownData.subStatuses}
                                handleCheckboxChange={handleCheckboxChange}
                                toggleDropDown={toggleDropDown}
                                dropdownContainer={dropdownContainer2}
                                title="TitleBox Sub-Status"
                                filterName="subStatuses"
                                selectedDropdownData={filterValues.subStatuses}
                              ></MultiSelectDropDownReset>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-5 mrg-all-0 pad-L5 ms-drpdwn ">
                              <MultiSelectDropDownReset
                                data={dropdownData.rtoAgents}
                                handleCheckboxChange={handleCheckboxChange}
                                toggleDropDown={toggleDropDown}
                                dropdownContainer={dropdownContainer3}
                                title="RTO Agent"
                                filterName="rtoAgents"
                                selectedDropdownData={filterValues.rtoAgents}
                              ></MultiSelectDropDownReset>
                            </div>
                          </div>
                        </div>
                        {visibilityObj.showStatusOptions ? (
                          <div className="col-lg-2 col-md-2 col-sm-6 ms-drpdwn pad-LR">
                            <MultiSelectDropDownReset
                              data={dropdownData.statuses}
                              handleCheckboxChange={handleCheckboxChange}
                              toggleDropDown={toggleDropDown}
                              dropdownContainer={dropdownContainer4}
                              title="Status"
                              filterName="statuses"
                              selectedDropdownData={filterValues.statuses}
                            ></MultiSelectDropDownReset>
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="col-lg-2 col-md-2 col-sm-3 pad-LR">
                          <div className="form-group">
                            <button
                              type="submit"
                              className="btn rc-btn_primary pad-L20 pad-R20 mar-R3 searchResults"
                              disabled={isLoading}
                              onClick={fetchListData}
                            >
                              {isLoading ? "Please wait.." : "Search"}
                            </button>
                            <button
                              type="button"
                              className="btn rc-btn_rset pad-L20 pad-R20"
                              onClick={resetFunc}
                              disabled={isLoading}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="container-fluid" id="list_data">
                  <div className="list-box mrg-T20 mrg-B20">
                    <div className="fixed-tabnavs filter_flyout dts_tab_navs">
                      <ul className="nav nav-tabs" role="tablist">
                        <li
                          data-input="0"
                          role="presentation"
                          className="active"
                        >
                          <a href="#mycase" aria-controls="My Cases" role="tab">
                            Withheld Charges
                            <RefreshSpin
                              isLoading={isLoading}
                              count={caseDetails.tabCount}
                            />
                            <span
                              className="badge flagged"
                              id="spanMycase"
                            ></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div
                      className="tab-content ad-fx-cls"
                      style={{ marginTop: "0px" }}
                    >
                      {!isLoading ? (
                        <WithheldTable
                          caseData={caseDetails.caseData}
                          total={caseDetails.tabCount}
                          sortingColumns={sortingColumns}
                          handleSorting={handleSorting}
                          user={user}
                          withheldCheckboxes={withheldCheckboxes}
                          handleWithheldTableCheckboxChange={
                            handleWithheldTableCheckboxChange
                          }
                          page={page}
                          prevPage={prevPage}
                          nextPage={nextPage}
                          pageSelected={pageSelected}
                          openGalleryModal={openGalleryModal}
                          openRemarksModal={openRemarksModal}
                          openPayeeDetailModal={openPayeeDetailsModal}
                        />
                      ) : (
                        <div
                          id="dtsMycase_processing"
                          className="dataTables_processing"
                          style={{ textAlign: "center" }}
                        >
                          <img
                            src={`${process.env.REACT_APP_STYLES_PATH}page-loader.gif`}
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="pull-right">
                    <span className="label label-default modified-label">
                      <span id="chk_selected">{countSelectedCheckboxes()}</span>{" "}
                      out of <span id="chk_total">{caseDetails.tabCount}</span>{" "}
                      selected
                    </span>
                    <button
                      id="withheld_submit_btn payBtn"
                      type="button"
                      className="btn rc-btn_primary pad-L20 pad-R20 mrg-R5 "
                      onClick={(e) => openConfirmationModal(e)}
                    >
                      {visibilityObj.submitBtnText}
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className="arrowTop">
        {showArrowTopButton ? (
          <div className="pageToup">
            <button
              id="go-top"
              onClick={() =>
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
              }
            >
              <span className="fa fa-arrow-up" aria-hidden="true"></span>
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </span>
  );
};

export default WithheldPanel;
